import React, { useEffect, forwardRef } from 'react';

interface ClickOutsideProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ClickOutside = forwardRef<HTMLDivElement, ClickOutsideProps>(
  ({ isModalOpen, setIsModalOpen }, ref) => {
    useEffect(() => {
      const handleMouseDown = (event: MouseEvent) => {
        const modalElement = (ref as React.MutableRefObject<HTMLDivElement | null>).current;

        if (modalElement && !modalElement.contains(event.target as Node)) {
          setIsModalOpen(false);
        }
      };

      if (isModalOpen) {
        document.addEventListener("mousedown", handleMouseDown);
      }

      return () => {
        document.removeEventListener("mousedown", handleMouseDown);
      };
    }, [isModalOpen, setIsModalOpen, ref]);

    return null; 
  }
);

export default ClickOutside;
